// Sidebar_Campaigns.tsx
import Sidebar, { PageItem } from "./sidebar";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

const pages: PageItem[] = [
  { name: "Campaign Pathways", link: "/campaigns/", icon: <AccountTreeIcon /> },
];

export default function Sidebar_Campaigns() {
  return <Sidebar pages={pages} primaryColorKey="campaigns" />;
}
